export default __webpack_public_path__ + "static/media/Padron_3000Closed.266a46af.jpg";